<template>
    <div class="timeline-wrapper">

        <b-button size="sm"  style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px" @click="toggleSecondTimeline = !toggleSecondTimeline" variant="primary" class="mb-3">
            {{ toggleSecondTimeline ? 'Hide' : 'Show' }} Final Steps
        </b-button>

        <div class="assignment-details">
            <h3>Assignment Details</h3>
            <div class="details-grid">
                <div><strong>Job No:</strong> {{ eventDet.JobNo }}</div>
                <div><strong>Job Date:</strong> {{ eventDet.JobDate }}</div>
                <div><strong>Raised By:</strong> {{ eventDet.RaisedBy }}</div>
                <div><strong>Raised From:</strong> {{ eventDet.RaisedFrom }}</div>
                <div><strong>Client:</strong> {{ eventDet.ClientName }}</div>
                <div><strong>Sline:</strong> {{ eventDet.SlineName }}</div>
                <div><strong>Transport Type:</strong> {{ eventDet.TransportType }}</div>
                <div><strong>Vessel/Voyage:</strong> {{ eventDet.VesselVoyage }}</div>
                <div><strong>BRF No:</strong> {{ eventDet.BrfNo }}</div>
                <div><strong>IncoTerm:</strong> {{ eventDet.IncoTerm }}</div>
                <div><strong>HBL No:</strong> {{ eventDet.HblNo }}</div>
                <div><strong>MBL No:</strong> {{ eventDet.MblNo }}</div>
                <div><strong>MBL Date:</strong> {{ (eventDet.MblDate) }}</div>
                <div><strong>Release Date:</strong> {{ (eventDet.MblReleaseDate) }}</div>
                <div><strong>ETA Estimated:</strong> {{ (eventDet.EtaEstimated) }}</div>
                <div><strong>ETA Actual:</strong> {{ (eventDet.EtaActual) }}</div>
                <div :style="(eventDet && eventDet.subscription_id) ? 'color: blue;font-weight:bold' : ''" @click="
                    (eventDet && eventDet.subscription_id) ? goToSubscriptionPage(eventDet) : ''
                    "><strong>Booking No:</strong> {{ (eventDet.BookingNumber) }}</div>
                <div><strong>Next Port:</strong> {{ (eventDet.NextPort) }}</div>
                <div><strong>Current Vessel:</strong> {{ (eventDet.CurrentVessel) }}</div>
                <div md="4" v-if="
                    eventDet.validity_doc != '' &&
                    eventDet.validity_doc != undefined &&
                    eventDet.validity_doc != null
                ">
                    <span v-if="eventDet.validity_doc">
                        <b v-if="eventDet.validity_doc.split(',').length > 0">
                            <span v-for="(item_doc, index_doc) in sanitizedArray(eventDet.validity_doc.split(','))"
                                :key="index_doc">
                                <a class="btn btn-xs btn-warning" size="sm" style="font-size: 0.675rem"
                                    v-if="item_doc != ''" href="javascript:void(0)"
                                    @click="PrintValidity_Doc(item_doc)">View
                                    Doc - {{ index_doc + 1
                                    }}</a>
                                <br />
                            </span>
                        </b>
                    </span>
                </div>
            </div>
        </div>

        <div class="timeline-container">
            <div v-for="(event, index) in timelineEvents" :key="'t1-' + index" class="timeline-step">
                <div class="circle" :class="{ missing: !event.actual && !event.plan, blinking: shouldBlink(event) }"
                    :title="event.label"></div>
                <div class="port-label">{{ event.label }}</div>
                <div class="details">
                    <div v-if="event.plan"><span class="badge badge-info">Planned</span>: {{ event.plan }}</div>
                    <div v-if="event.last"><span class="badge badge-warning">Last</span>: {{ event.last }}</div>
                    <div v-if="event.actual"><span class="badge badge-success">Actual</span>: {{ event.actual }}</div>
                    <div v-if="event.detected"><span class="badge badge-secondary">Detected</span>: {{ event.detected }}
                    </div>
                    <div v-if="!event.plan && !event.last && !event.actual && !event.detected" class="missing-text">No
                        Data</div>
                </div>
                <div v-if="index < timelineEvents.length - 1" class="line"></div>
            </div>
        </div>

        <div v-show="toggleSecondTimeline" class="timeline-container second">
            <div v-for="(event, index) in timelineEvents2" :key="'t2-' + index" class="timeline-step">
                <div class="circle" :class="{ missing: !event.actual && !event.plan, blinking: shouldBlink(event) }"
                    :title="event.label"></div>
                <div class="port-label">{{ event.label }}</div>
                <div class="details">
                    <div v-if="event.plan"><span class="badge badge-info">Planned</span>: {{ event.plan }}</div>
                    <div v-if="event.last"><span class="badge badge-warning">Last</span>: {{ event.last }}</div>
                    <div v-if="event.actual"><span class="badge badge-success">Actual</span>: {{ event.actual }}</div>
                    <div v-if="event.detected"><span class="badge badge-secondary">Detected</span>: {{ event.detected }}
                    </div>
                    <div v-if="!event.plan && !event.last && !event.actual && !event.detected" class="missing-text">No
                        Data</div>
                </div>
                <div v-if="index < timelineEvents2.length - 1" class="line"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
export default {
    name: 'ShipmentTimeline',
    props: {
        eventDet: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            toggleSecondTimeline: true,
            docURL: URL_BASE_DOC,
        };
    },
    computed: {
        timelineEvents() {
            const e = this.eventDet;
            return [
                {
                    label: `Empty Pickup: ${e.EmptyPickupLoc || '-'}`,
                    plan: e.EmptyPickupPlanInitial || '',
                    last: e.EmptyPickupPlanLast || '',
                    actual: e.EmptyPickupPlanActual || '',
                    detected: '',
                },
                {
                    label: `Origin: ${e.OriginLoc || '-'}`,
                    plan: e.OriginPlanInitial || '',
                    last: e.OriginPlanLast || '',
                    actual: e.OriginPlanActual || '',
                    detected: '',
                },
                {
                    label: `POL: ${e.PolLoc || '-'}`,
                    plan: e.PolPlanInitial || '',
                    last: e.PolPlanLast || '',
                    actual: e.PolPlanActual || '',
                    detected: '',
                },
                {
                    label: 'SOB Plan',
                    plan: e.SobPlanInitial || '',
                    last: e.SobPlanLast || '',
                    actual: e.SobPlanActual || '',
                    detected: e.SobPlanDetected || '',
                },
                {
                    label: `TSP1: ${e.Tsp1Loc || '-'}`,
                    plan: e.Tsp1PlanInitial || '',
                    last: e.Tsp1PlanLast || '',
                    actual: e.Tsp1PlanActual || '',
                    detected: '',
                },
                {
                    label: `TSP1 Departure`,
                    plan: e.Tsp1DepartureInitial || '',
                    last: e.Tsp1DepartureLast || '',
                    actual: e.Tsp1DepartureActual || '',
                    detected: e.Tsp1VslArrivalPrediction || '',
                },

                {
                    label: `TSP2: ${e.Tsp2Loc || '-'}`,
                    plan: e.Tsp2PlanInitial || '',
                    last: e.Tsp2PlanLast || '',
                    actual: e.Tsp2PlanActual || '',
                    detected: '',
                },

                {
                    label: `TSP2 Departure`,
                    plan: e.Tsp2DepartureInitial || '',
                    last: e.Tsp2DepartureLast || '',
                    actual: e.Tsp2DepartureActual || '',
                    detected: e.Tsp2VslArrivalPrediction || '',
                },
            ];
        },
        timelineEvents2() {
            const e = this.eventDet;
            return [

                {
                    label: `Empty Return: ${e.EmptyReturnLoc || '-'}`,
                    plan: e.EmptyReturnPlanInitial || '',
                    last: e.EmptyReturnPlanLast || '',
                    actual: e.EmptyReturnPlanActual || '',
                    detected: '',
                },

                {
                    label: `DLV: ${e.DlvLoc || '-'}`,
                    plan: e.DlvPlanInitial || '',
                    last: e.DlvPlanLast || '',
                    actual: e.DlvPlanActual || '',
                    detected: '',
                },
                {
                    label: `POD Departure: `,
                    plan: e.PodDepartureInitial || '',
                    last: e.PodDepartureLast || '',
                    actual: e.PodDepartureActual || '',
                    detected: '',
                },
                {
                    label: `POD Discharge: `,
                    plan: e.PodDischargeInitial || '',
                    last: e.PodDischargeLast || '',
                    actual: e.PodDischargeActual || '',
                    detected: '',
                },
                {
                    label: `POD: ${e.PodLoc || '-'}`,
                    plan: e.PodPlanInitial || '',
                    last: e.PodPlanLast || '',
                    actual: e.PodPlanActual || '',
                    detected: '',
                },

                {
                    label: 'Vessel/Voyage',
                    plan: e.Voyage1,
                    last: e.Voyage2,
                    actual: e.Vessel1,
                    detected: e.Vessel2,
                },
                {
                    label: 'MBL Release',
                    plan: '',
                    last: '',
                    actual: e.MblReleaseDate || '',
                    detected: '',
                },
                {
                    label: 'MBL Date',
                    plan: '',
                    last: '',
                    actual: e.MblDate || '',
                    detected: '',
                },
            ];
        },
    },
    methods: {
        shouldBlink(event) {
            // return !!event.plan && !event.last && !event.actual && !event.detected;
            //   return !event.label || !event.plan || !event.last || !event.actual || !event.detected;
            //   return !event.label || !event.plan || !event.actual;
              return (!event.label || !event.plan || !event.actual) && (!event.plan !== !event.actual);
        },
        goToSubscriptionPage(item) {
            if (item.subscription_id) {
                this.$router.push({
                    path: "/tracking/ocean-insights/subscription/" + item.subscription_id,
                });
            }
        },
        sanitizedArray(validity_doc) {
            // Use the map method to replace "\n" with []
            const replacedArray = validity_doc.map((item) => {
                if (item === "\n") {
                    return [];
                } else {
                    return item;
                }
            });
            // Flatten the replacedArray and remove empty arrays
            const flattenedArray = replacedArray.reduce((acc, curr) => {
                if (Array.isArray(curr) && curr.length === 0) {
                    return acc;
                }
                return acc.concat(curr);
            }, []);

            // console.log("validity_doc2 =>", flattenedArray);
            return flattenedArray;
        },
        PrintValidity_Doc(validity_doc) {
            this.openSignedDocument(`ASSIGNMENT_UPLOADS/Console_Booking_Doc/${validity_doc}`);
        },
    },
};
</script>

<style scoped>
@keyframes blink {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }
}

.circle.blinking {
    animation: blink 1s infinite;
}

.assignment-details {
    background: #f4f6f8;
    border-radius: 12px;
    padding: 2px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1px;
    margin-top: 1px;
    font-size: 10px;
}

.timeline-wrapper {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.timeline-container {
    display: flex;
    align-items: flex-start;
    overflow-x: auto;
    margin-top: 10px;
    padding-bottom: 10px;
}

.timeline-container.second {
    border-top: 2px dashed #aaa;
    padding-top: 20px;
}

.timeline-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 150px;
    position: relative;
    margin-right: 40px;
    animation: fadeInUp 0.4s ease-in-out;
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.circle {
    width: 18px;
    height: 18px;
    background: linear-gradient(145deg, #6dd5ed, #2193b0);
    border-radius: 50%;
    box-shadow: 0 0 8px rgba(0, 123, 255, 0.4);
    border: 2px solid #fff;
}

.circle.missing {
    background: linear-gradient(145deg, #e67e22, #ff6b6b);
    box-shadow: 0 0 6px rgba(231, 76, 60, 0.4);
}

.line {
    position: absolute;
    top: 8px;
    left: 50%;
    height: 2px;
    width: 140px;
    background-color: #ccc;
    z-index: 0;
}

.port-label {
    margin-top: 8px;
    font-weight: 600;
    text-align: center;
    font-size: 13px;
}

.details {
    font-size: 11px;
    margin-top: 6px;
    padding: 6px;
    background: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    text-align: center;
    white-space: nowrap;
}

.missing-text {
    color: #e74c3c;
    font-weight: bold;
}

.badge {
    font-size: 10px;
    border-radius: 10px;
    padding: 2px 6px;
    margin-right: 4px;
}

.badge-info {
    background-color: #17a2b8;
    color: white;
}

.badge-success {
    background-color: #28a745;
    color: white;
}

.badge-warning {
    background-color: #ffc107;
    color: #212529;
}

.badge-secondary {
    background-color: #6c757d;
    color: white;
}
</style>



// WEBPACK FOOTER //
// ShipmentTimeline.vue?1bd86f43